import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useEffect, useState } from 'react';
import { FaCalculator, FaPercent, FaSave, FaShieldAlt, FaSlidersH } from 'react-icons/fa';
import { ParameterType } from '../../../../redux/userStore/reducer';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { getParameter, updateParameter } from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';

const Container = styled.div`
  min-height: calc(100vh - 76px);
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 79, 31, 0.08), transparent 24%),
    radial-gradient(circle at 92% 8%, rgba(255, 176, 0, 0.08), transparent 22%),
    var(--mt-bg);
  color: var(--mt-text);
  font-family: Poppins-R;

  .bread-crum span {
    color: var(--mt-text);
  }

  .ant-form-item,
  .ant-form-item-label label {
    color: var(--mt-text);
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: var(--mt-row-odd);
    color: var(--mt-text);
  }

  .even-row {
    background-color: var(--mt-row-even);
    color: var(--mt-text);
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: var(--mt-text);
    }
  }

  .content {
    padding: 12px;
    width: 100%;
    background: transparent;
    color: var(--mt-text);
  }

  .settings-hero {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 18px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.13), transparent 38%),
      ${PRIMARY};
    box-shadow: var(--mt-card-shadow);
  }

  .eyebrow {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .settings-hero h1 {
    margin: 6px 0 0;
    color: #fff7e8;
    font-family: Poppins-B;
    font-size: 30px;
  }

  .settings-hero p {
    max-width: 760px;
    margin: 8px 0 0;
    color: rgba(255, 247, 232, 0.72);
  }

  .settings-badge {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid rgba(255, 176, 0, 0.28);
    border-radius: 8px;
    padding: 12px;
    color: #fff7e8;
    background: rgba(255, 255, 255, 0.06);
    font-family: Poppins-B;
  }

  .settings-layout {
    display: grid;
    grid-template-columns: minmax(0, 620px) 1fr;
    gap: 12px;
    margin-top: 12px;
  }

  .settings-form {
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid var(--mt-border);
    background: var(--mt-card);
    box-shadow: var(--mt-card-shadow);
  }

  .settings-form h2 {
    margin: 0 0 14px;
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 18px;
  }

  .ant-input {
    height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .save-button {
    min-width: 190px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, ${YELLOW});
    color: #07141c;
    font-family: Poppins-B;
  }

  .info-panel {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 18px;
    background: var(--mt-card);
    box-shadow: var(--mt-card-shadow);
  }

  .impact-panel {
    margin-top: 12px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 14px;
    background:
      linear-gradient(135deg, rgba(255, 176, 0, 0.08), transparent 48%),
      var(--mt-surface);
  }

  .impact-panel h4 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 10px;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .impact-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 0;
    border-top: 1px solid var(--mt-border);
  }

  .impact-row:first-of-type {
    border-top: 0;
  }

  .impact-row span {
    color: var(--mt-muted);
  }

  .impact-row strong {
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .impact-row.total strong {
    color: ${YELLOW};
    font-size: 18px;
  }

  .info-panel h3 {
    margin: 0;
    color: var(--mt-warning);
    font-family: Poppins-B;
  }

  .info-panel p {
    color: var(--mt-muted);
    line-height: 1.6;
  }

  .rate-preview {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 14px;
  }

  .rate-preview div {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 12px;
    background: var(--mt-surface);
  }

  .rate-preview span {
    display: block;
    color: var(--mt-muted);
    font-size: 11px;
    text-transform: uppercase;
  }

  .rate-preview strong {
    display: block;
    margin-top: 6px;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  @media (max-width: 760px) {
    .content {
      padding: 18px 12px;
    }

    .settings-form {
      padding: 16px;
    }

    .settings-layout {
      grid-template-columns: 1fr;
    }
  }
`;

export const ParameterPage = () => {
  const [parameter, setParameter] = useState<ParameterType>();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
      setIsLoading(true);
      getParameter(1).then(({ data: response }) => {
        setParameter(response);
        setIsLoading(false);
      });
  };

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  form.setFieldsValue(parameter);

  const formatRateAsPercent = (value?: number | string) => {
    const numericValue = Number(value);

    if (value === undefined || value === null || Number.isNaN(numericValue)) {
      return '--';
    }

    return `${(numericValue * 100).toFixed(2)}%`;
  };

  const sampleAmount = 10000000;
  const getRateAmount = (value?: number | string) => sampleAmount * Number(value || 0);
  const sampleFees =
    getRateAmount(parameter?.com_intermediation) +
    getRateAmount(parameter?.com_conservation) +
    getRateAmount(parameter?.droit_garde) +
    getRateAmount(parameter?.com_courtage);

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <section className='settings-hero'>
            <div>
              <span className='eyebrow'>Administration</span>
              <h1>Paramètres de commissions</h1>
              <p>
                Ajustez les taux appliqués aux opérations de marché avec une
                lecture claire des frais actifs.
              </p>
            </div>
            <div className='settings-badge'>
              <FaShieldAlt />
              Paramètres système
            </div>
          </section>

          <div className='settings-layout'>
              <Form
                layout='vertical'
                className='settings-form'
                form={form}
                initialValues={parameter}
                labelCol={{ span: 40 }}
                wrapperCol={{ span: 25 }}
                onFinish={async (data) => {
                  setIsLoading(true);
                  // update user
                  console.log(data);
                  await updateParameter(1, data).then(
                    ({ data, statusCode }) => {
                      if (statusCode?.toString()[0] === '2') {
                        notification.success({
                          message: 'Succès',
                          description:
                            'Les parametres ont été mis à jour avec succès',
                        });
                        setParameter(data);
                      } else {
                        notification.info({
                          message: 'Erreur',
                          description: data.message,
                        });
                      }
                      setIsLoading(false);
                    },
                  );
                }}
              >
                <h2>Barème opérationnel</h2>
                <Form.Item
                  label="Taux de Commission d'intermediation "
                  name='com_intermediation'
                  rules={[
                    {
                      required: true,
                      message:
                        "Entrez le taux de la commission d'intermediation",
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la commission'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Commission de conservation '
                  name='com_conservation'
                  rules={[
                    {
                      required: true,
                      message:
                        'Entrez le taux de la commission de conservation',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la de conservation'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Droit de garde '
                  name='droit_garde'
                  rules={[
                    {
                      required: true,
                      message: 'Entrez le taux du Droit de garde',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux du Droit de garde'
                  />
                </Form.Item>
                <Form.Item
                  label='Taux de Commission de courtage '
                  name='com_courtage'
                  rules={[
                    {
                      required: true,
                      message: 'Entrez le taux de la commission de courtage',
                    },
                  ]}
                  style={{ marginBottom: 5 }}
                >
                  <Input
                    type='number'
                    placeholder='Entrez le taux de la commission de courtage'
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    className='save-button'
                    htmlType='submit'
                    loading={isLoading}
                    icon={<FaSave />}
                  >
                    Enregistrer
                  </Button>
                </Form.Item>
              </Form>

              <aside className='info-panel'>
                <h3><FaSlidersH /> Synthèse active</h3>
                <p>
                  Ces paramètres alimentent les calculs de coût, de règlement
                  et de net à payer dans les parcours de trading.
                </p>
                <div className='rate-preview'>
                  <div><span>Intermédiation</span><strong>{formatRateAsPercent(parameter?.com_intermediation)}</strong></div>
                  <div><span>Conservation</span><strong>{formatRateAsPercent(parameter?.com_conservation)}</strong></div>
                  <div><span>Droit de garde</span><strong>{formatRateAsPercent(parameter?.droit_garde)}</strong></div>
                  <div><span>Courtage</span><strong>{formatRateAsPercent(parameter?.com_courtage)}</strong></div>
                </div>
                <p><FaPercent /> Les valeurs sont exprimées en pourcentage.</p>
                <div className='impact-panel'>
                  <h4><FaCalculator /> Simulation sur 10 000 000 XAF</h4>
                  <div className='impact-row'>
                    <span>Intermédiation</span>
                    <strong>{formatCurrency(getRateAmount(parameter?.com_intermediation))}</strong>
                  </div>
                  <div className='impact-row'>
                    <span>Conservation</span>
                    <strong>{formatCurrency(getRateAmount(parameter?.com_conservation))}</strong>
                  </div>
                  <div className='impact-row'>
                    <span>Droit de garde</span>
                    <strong>{formatCurrency(getRateAmount(parameter?.droit_garde))}</strong>
                  </div>
                  <div className='impact-row'>
                    <span>Courtage</span>
                    <strong>{formatCurrency(getRateAmount(parameter?.com_courtage))}</strong>
                  </div>
                  <div className='impact-row total'>
                    <span>Total frais estimés</span>
                    <strong>{formatCurrency(sampleFees)}</strong>
                  </div>
                </div>
              </aside>
            </div>
        </div>
      </Container>
    </Layout>
  );
};

const formatCurrency = (value: number) =>
  `${Math.round(value).toLocaleString('fr-FR')} XAF`;
